(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesDeleteController', TabObjectTypesDeleteController);

    TabObjectTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabObjectTypes'];

    function TabObjectTypesDeleteController($uibModalInstance, entity, TabObjectTypes) {
        var vm = this;
        vm.tabObjectTypes = entity;
        vm.hasIndices = false;
        vm.clear = function () {
            vm.hasIndices = false;
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id, decision) {
            vm.hasIndices = false;
            TabObjectTypes.delete({id: id, decision: decision},
                function () {
                    $uibModalInstance.close(true);
                },
                function (response) {
                    if (response.status === 449) {
                        vm.hasIndices = true;
                    }
                });
        };
    }
})();
